

















































































































































































































import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import {
  GET_USER_DETAILS,
  GET_COMPANY_DETAILS,
  USER_STATE
} from "@/store/modules/auth/constants";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { get_name_initials } from "@/utils/global";
import { get_color_by_name, get_random_color_hash } from "@/utils/colors";
import { ROOT_ERROR } from "@/store/modules/root/constants";
import UserInfoWithIcon from "@/components/shared/view_profile/UserInfoWithIcon.vue";
import { UserState } from "@/store/modules/auth/interfaces";

export default Vue.extend({
  name: "ViewCandidateProfile",
  components: {
    UserInfoWithIcon,
    GoBackHeader
  },
  data() {
    return {
      social_icons: {
        linkedin: require("@/assets/logos/linkedin-3.svg"),
        twitter: require("@/assets/logos/twitter.svg"),
        instagram: require("@/assets/logos/instagram.svg"),
        facebook: require("@/assets/logos/facebook.svg")
      }
    };
  },
  computed: {
    ...mapGetters("auth", {
      user_details: GET_USER_DETAILS,
      get_company_details: GET_COMPANY_DETAILS,
      get_user_state: USER_STATE
    }),
    UserState() {
      return UserState;
    },
    company_profile_image(): string | null {
      return this.get_company_details?.links?.images?.profile?.location
        ? this.get_company_details.links.images.profile.location
        : null;
    },
    company_cover_image(): string | null {
      return this.get_company_details?.links?.images?.cover?.location
        ? this.get_company_details.links.images.cover.location
        : null;
    },
    company_name(): string {
      return (
        this.get_company_details?.public_name ||
        this.get_company_details?.company_name
      );
    },
    company_name_initials(): string {
      return get_name_initials(this.company_name);
    },
    company_linkedIn_link(): string {
      return this.get_company_details?.links?.linkedin || "";
    },
    company_facebook_link(): string {
      return this.get_company_details?.links?.facebook || "";
    },
    company_instagram_link(): string {
      return this.get_company_details?.links?.instagram || "";
    },
    company_twitter_link(): string {
      return this.get_company_details?.links?.twitter || "";
    }
  },
  methods: {
    ...mapMutations({
      root_error: ROOT_ERROR
    }),
    get_color_by_name,
    get_random_color_hash,
    get_name_initials,
    transform_edit_icon(icon: HTMLElement): HTMLElement {
      const color = get_color_by_name("primary");
      for (let node of icon.children) node.setAttribute("stroke", color);
      return icon;
    }
  }
});
